import { L as LOGIN_FAILED, e as LOGIN_SUCCESS, S as SET_IS_LOADING, f as LOGOUT, P as PASSWORD_RESET_FAILED, g as PASSWORD_RESET_SUCCESS, V as VERIFY_PASSWORD_RESET_FAILURE, h as VERIFY_PASSWORD_RESET_SUCCESS } from './types-0b7e03a3.js';

var login = function login(userCredentials) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/auth/login"), {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(userCredentials)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: LOGIN_FAILED,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};
var setIsLoading = function setIsLoading(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: SET_IS_LOADING,
        payload: data
      });
      resolve(data);
    });
  };
};
var logout = function logout() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/auth/logout"), {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'include'
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: LOGOUT
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var resetPassword = function resetPassword(form) {
  return function (dispatch) {
    var email = form.email;
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/users/passwordReset/").concat(email), {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        }
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: PASSWORD_RESET_FAILED,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: PASSWORD_RESET_SUCCESS,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};
var verifyPasswordReset = function verifyPasswordReset() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var data = getState().form.VerifyForm.values;
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/users/verifypasswordreset"), {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(data)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: VERIFY_PASSWORD_RESET_FAILURE,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: VERIFY_PASSWORD_RESET_SUCCESS,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};
var checkIsLoggedIn = function checkIsLoggedIn() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/auth/loggedin"), {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'include'
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: LOGIN_FAILED,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};
var generate2FASecret = function generate2FASecret(user) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/auth/2fa/generateSecret"), {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(user)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: LOGIN_FAILED,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};
var verify2FASecret = function verify2FASecret(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL, "/api/v1/auth/2fa/verify2FA"), {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(data)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: LOGIN_FAILED,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};

export { checkIsLoggedIn, generate2FASecret, login, logout, resetPassword, setIsLoading, verify2FASecret, verifyPasswordReset };
